import { Component, OnInit } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { Button } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PageProfileDataInterface } from '../../types/performance-profile.type';
import { AssignedProfilesRepoService } from '@client/app/services/api/page-performance/assigned-profile-repo/assigned-profiles-repo.service';
import { DEFAULT_PAGE_SIZE, AVAILABLE_PAGE_SIZE } from '@client/app/shared-modules/api/constants/page-size.constant';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'mon-archive-performance-profile-dialog',
    standalone: true,
    imports: [
        CommonModule,
        TranslocoModule,
        PaginatorModule,
        Button,
        ProgressSpinnerModule,
    ],
    templateUrl: './archive-performance-profile-dialog.component.html',
    styleUrls: ['./archive-performance-profile-dialog.component.scss'],
})
export class ArchivePerformanceProfileDialogComponent implements OnInit {
    readonly AVAILABLE_PAGE_SIZE = AVAILABLE_PAGE_SIZE;

    profileData: PageProfileDataInterface | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    assignedProfileData: any | undefined;
    tableFirstOffset = 0;
    perPage = 0;
    total = 0;
    pageNumber: number | undefined = 0;
    pageSize: number | undefined = DEFAULT_PAGE_SIZE;
    isLoading: boolean = false;

    constructor (
        private readonly dialogRef: DynamicDialogRef,
        private readonly dialogConfig: DynamicDialogConfig,
        private assignedProfilesRepoService: AssignedProfilesRepoService,
    ) {}

    ngOnInit (): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.profileData = this.dialogConfig.data;
        this.getAssignedProfileData();
    }

    async getAssignedProfileData () {
        this.isLoading = true;
        const assignedProfileData = await this.assignedProfilesRepoService.getAll({
            profile_id: this.profileData?.id,
            page: (this.pageNumber || 0) + 1,
            page_size: this.pageSize,
        });
        this.assignedProfileData = assignedProfileData;
        this.perPage = assignedProfileData.perPage || 0;
        this.tableFirstOffset = ((assignedProfileData.currentPage || 1) - 1) * this.perPage;
        this.total = assignedProfileData.total || 0;
        this.isLoading = false;
    }

    cancel (): void {
        this.dialogRef.close(null);
    }

    confirm (): void {
        this.dialogRef.close(true);
    }

    onPageSizeChange (paginatorState: PaginatorState) {
        this.pageNumber = paginatorState.page;
        this.pageSize = paginatorState.rows;
        this.getAssignedProfileData();
    }
}
